export const getCommissionsUrl = "admin/commissions";
